module.exports = __webpack_public_path__ + "d615e1bcef23ad88c2185e82e69f6037.svg";